export default __webpack_public_path__ + "media/images/favicon/favicon-152x152-29a0ea514f42895a73ca96a5b7a330aa.png";